import {gql} from '@apollo/client';

/**
 * 审核罚单申诉（标记通过/驳回），对应 api-server `PartnerControlAppealReviewMutation.reviewAppealTicket`。
 *
 * `action` 透传给 base-data-service，值就是目标审核状态（`PartnerPenaltyStatus` 的 value），
 * 不是一个独立的动作枚举——只能是 APPROVED(3)、REJECTED(4) 或 WAITING(7)。
 */

export enum ReviewAppealTicketAction {
    APPROVE = 3,
    REJECT = 4,
    WAITING = 7,
}

export const REVIEW_APPEAL_TICKET = gql`
    mutation ReviewAppealTicket($id: Long!, $action: Int!, $rejectReason: String) {
        reviewAppealTicket(id: $id, action: $action, rejectReason: $rejectReason)
    }
`;

export interface ReviewAppealTicketResponse {
    reviewAppealTicket: boolean;
}
